import React from 'react';

import { WebinarPlayerContext } from '$/components/WebinarPlayer/context';

import { RoomType } from '$/GraphQL/schema/schema';
import { useThemeContext } from '$/components/ui/ThemeContext';
import formatTimeInWebinarSecs from '$/utils/formatTimeInWebinarSecs';
import { css } from '@emotion/react';
import { BoxedText } from '../BoxedText';
import { ZoomScaleProviderContext } from './ZoomScaleProviderContext';

// timeline bottom bar showing various times
export const TimelineTrackLabels: React.FC = () => {
  const { zoomScale, zoom } = React.useContext(ZoomScaleProviderContext);
  const { rooms, colors, timelineComponents, interactionInEdit } =
    React.useContext(WebinarPlayerContext);

  const min = zoomScale!.domain()[0];
  const max = zoomScale!.domain()[1];
  const room = rooms.getRoom(RoomType.Presentation);

  const xStartPresentation = zoomScale!(0) ?? 1;
  const xEndPresentation = zoomScale!(room.duration) ?? 1;
  const etheme = useThemeContext();

  if (!timelineComponents.time) {
    return null;
  }

  const y = timelineComponents.time.offset + timelineComponents.time.height / 2;

  return (
    <g>
      {interactionInEdit?.hasVideoOverlay() !== 'over-video' && (
        <text
          x={xStartPresentation}
          y={y}
          fill={etheme.player.timeline.marker.fg}
          textAnchor='start'
          alignmentBaseline='middle'
          style={{
            opacity:
              xStartPresentation > zoom!.translateExtent()[1][0] || xStartPresentation < 0 ? 0 : 1,
          }}
        >
          {formatTimeInWebinarSecs(0)}
        </text>
      )}
      <BoxedText
        x={zoom!.translateExtent()[0][0] + 10}
        y={y}
        textColor={'#7C8A8D'}
        bgColor={colors.controlBg}
        minHeight={timelineComponents.time.height}
        alignmentBaseline='middle'
        textAnchor='start'
      >
        {formatTimeInWebinarSecs(min)}
      </BoxedText>

      {/* End of presentation time */}
      <BoxedText
        x={xEndPresentation}
        y={y}
        textColor={'#7C8A8D'}
        bgColor={colors.controlBg}
        minHeight={timelineComponents.time.height}
        alignmentBaseline='middle'
        textAnchor='end'
        css={css`
          opacity: ${xEndPresentation >= zoom!.translateExtent()[1][0] || xEndPresentation < 0
            ? 0
            : 1};
        `}
      >
        {formatTimeInWebinarSecs(room.duration)}
      </BoxedText>

      <BoxedText
        x={zoom!.translateExtent()[1][0] - 10}
        y={y}
        bgColor={colors.controlBg}
        minHeight={timelineComponents.time.height}
        textColor={'#7C8A8D'}
        alignmentBaseline='middle'
        textAnchor='end'
      >
        {formatTimeInWebinarSecs(max)}
      </BoxedText>
    </g>
  );
};
